module.exports = __webpack_public_path__ + "static/media/susan2.d09504a9.mp3";